import { List as UIList } from '@faststore/ui'
import React, { useState } from 'react'

import FooterAppLinks from './FooterAppLinks'
import { links } from './FooterLinksStructure'
import { useFAQContext } from '../../../contexts/FAQContext'
import { useStoreContext } from '../../../contexts/StoreContext'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import Accordion, { AccordionItem } from '../../ui/Accordion'
import Link from '../../ui/Link'

import type { LinkItem, Links } from './FooterLinksStructure'

interface LinksListProps {
  items: LinkItem[]
}

function LinksList({ items }: LinksListProps) {
  const { handleChangeTopic } = useFAQContext()
  return (
    <UIList>
      {items.map((item) => (
        <li key={item.href}>
          <Link
            onClick={() => {
              if (item.topic) {
                handleChangeTopic?.(item.topic)
              }
            }}
            variant="footer"
            to={item.href}
          >
            {item.name}
            {item?.additionalInfo && <p>{item.additionalInfo}</p>}
          </Link>
        </li>
      ))}
    </UIList>
  )
}

function FooterLinks() {
  const { isMobile } = useWindowDimensions()
  const [indicesExpanded, setIndicesExpanded] = useState<Set<number>>(
    new Set([])
  )

  const { hasAppLinks, storeInfos } = useStoreContext()

  const allLinks = links()

  const footerLinksRender: Links[] = (
    storeInfos.sectionLink?.length ? storeInfos.sectionLink : allLinks
  ) as Links[]

  const onChange = (index: number) => {
    if (indicesExpanded.has(index)) {
      indicesExpanded.delete(index)
      setIndicesExpanded(new Set(indicesExpanded))
    } else {
      setIndicesExpanded(new Set(indicesExpanded.add(index)))
    }
  }

  return (
    <>
      <section className="footer__links">
        {isMobile ? (
          <>
            <Accordion expandedIndices={indicesExpanded} onChange={onChange}>
              {footerLinksRender?.map((section, index) => (
                <AccordionItem
                  key={section.title}
                  isExpanded={indicesExpanded.has(index)}
                  buttonLabel={section.title}
                >
                  <LinksList items={section.items} />
                </AccordionItem>
              ))}
            </Accordion>
            {hasAppLinks && <FooterAppLinks />}
          </>
        ) : (
          <div className="footer__links-columns">
            {footerLinksRender?.map((section) => (
              <nav key={section.title}>
                <h2 className="title-sub-subsection">{section.title}</h2>
                <LinksList items={section.items} />
              </nav>
            ))}
            {hasAppLinks && <FooterAppLinks />}
          </div>
        )}
      </section>
    </>
  )
}

export default FooterLinks
